// extracted by mini-css-extract-plugin
module.exports = {"promotion_manager":"country_promotion_manager__2cOU3","card":"country_card__2Ndf9"};